module.exports = __webpack_public_path__ + "static/media/ic_home_location.720a4a88.svg";